import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import utilsModel from "../../../engines/libs/utilsModel";
import { getpawnShopObjMap } from "./config/pawnShopConfig";
import { pawnShopBackpackObjI } from "./const/pawnShopConst";
import pawnShopGame from "./pawnShopGame";
import pawnShopGameResultItem from "./pawnShopGameResultItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGameResult extends cc.Component {

    @property({type:cc.Node,displayName:"结算item"})
    item:cc.Node = null;

    @property({type:cc.Node,displayName:"买入content"})
    buyContent:cc.Node = null;

    @property({type:cc.Label,displayName:"总收入文本"})
    lb_GrossIncome:cc.Label = null;

    @property({type:cc.Label,displayName:"买入收入"})
    lb_Buy:cc.Label = null;

    buyAry:pawnShopBackpackObjI[] = [];
    gameScript:pawnShopGame = null;

    bindData(buyAry:pawnShopBackpackObjI[],game:pawnShopGame){
        this.gameScript = game;
        this.buyAry = buyAry;
        this.loadDialog();
    }

    loadDialog(){
        let buyMoney:number = 0;
        for(let i = 0; i<this.buyAry.length; i++){
            buyMoney -= this.buyAry[i].buyPrice;
            let node:cc.Node = cc.instantiate(this.item);
            node.setParent(this.buyContent);
            node.getComponent(pawnShopGameResultItem).bindData(getpawnShopObjMap()[this.buyAry[i].id]);
        }
        let totalMoney = buyMoney;
        this.lb_GrossIncome.string = data_control.getNumberFormat(totalMoney);
        // this.lb_Buy.string = data_control.getNumberFormat(buyMoney);
    }

    onBtnAgain(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // 重新招揽客人
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.gameScript.resetGame();
            this.closeThis();
        },()=>{},null,"典当铺观看视频重新招揽客人");
    }

    onclickBg(){
        this.gameScript.closeThis();
        this.closeThis();
        // 返回主页
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
